import { useMemo } from 'react'
import { useLingui } from '@lingui/react/macro'

export const useHttpErrorMsg = (): Record<string, () => string> => {
	const { t } = useLingui()

	return useMemo(
		() => ({
			'payment.method.blocked': () => t`Votre compte est bloqué.`,
			'policy.account.business.ro_methods': () =>
				t`Impossible de modifier les moyens de paiements d'un compte entreprise`,
			'policy.availability.extra': () =>
				t`L'extra n'est pas disponible sur ce créneau/cette salle`,
			'policy.availability.space': () =>
				t`L'espace demandé n'est pas disponible`,
			'policy.cancel': () => t`Impossible d'annuler cet évènement`,
			'policy.change.cancelled': () =>
				t`Impossible de modifier une résa annulée`,
			'policy.change.readonly': () => t`La résa n'est pas modifiable`,
			'policy.change.refund_in_progress': () =>
				t`Un remboursement est en cours`,
			'policy.change.toolate': () =>
				t`Impossible de modifier une résa hors délai`,
			'policy.code.already_used': () => t`Ce code a déjà été utilisé`,
			'policy.code.invalid.day_of_week': () =>
				t`Impossible d'utiliser un code le week-end`,
			'policy.code.invalid.duration': () =>
				t`Impossible d'utiliser un code pour une résa de moins de 1h30`,
			'policy.code.invalid.first_booking': () =>
				t`Impossible d'utiliser un code pour la première résa`,
			'policy.code.invalid.gofather': () =>
				t`Vous ne pouvez pas utiliser votre propre code parrain`,
			'policy.code.invalid.hours': () =>
				t`Impossible d'utiliser un code avant 9h ou après 18h`,
			'policy.duration': () => t`Durée invalide`,
			'policy.event.in_past': () => t`Impossible de réserver dans le passé`,
			'policy.extra.time': () => t`Il est trop tard pour modifier cet extra`,
			'policy.organizer.account': () =>
				t`L'organisateur n'appartient pas au même compte que vous`,
			'policy.status.expired': () => t`La réservation a expiré`,
			'policy.visit.deny': () =>
				t`Impossible de réserver une visite sur ce créneau/cette salle`,
			'policy.visit.invalid': () => t`Visite invalide`,
			'policy.visit.quotas': () => t`Quota de visites épuisé`,
			'user.already_in_account': () =>
				t`L'utilisateur que vous tentez d'ajouter a déjà été invité.`,
			'user.conflict': () =>
				t`L'utilisateur que vous tentez d'ajouter a déjà un compte avec l'email.`,
			'booking.policy.availability.space': () =>
				t`Le créneau sélectionné n'est plus disponible.`,
			'booking.policy.visit.deny': () =>
				t`Impossible de réserver une visite sur ce créneau/cette salle`,
			'booking.policy.visit.invalid': () => t`Visite invalide`,
			'booking.policy.visit.quotas': () =>
				t`Vous avez atteint le nombre maximum de visites`,
			'extend.policy.status.expired': () =>
				t`Oups, vous avez dépassé le délai pour finaliser votre réservation. Aucune inquiétude, nous allons immédiatement vous rembourser.`,
			'auth/account-exists-with-different-credential': () =>
				t`Ce compte est rattaché à un autre fournisseur`,
			'auth/email-already-in-use': () => t`Cet e-mail est déjà utilisé`,
			'auth/expired-action-code': () => t`Le lien a expiré`,
			'auth/internal-error': () =>
				t`Le serveur d'authentification a rencontré une erreur inattendue`,
			'auth/invalid-action-code': () => t`Le lien est invalide`,
			'auth/invalid-email': () => t`L'e-mail fourni est invalide`,
			'auth/popup-closed-by-user': () => t`La popup de connexion a été fermée`,
			'auth/too-many-requests': () =>
				t`Veuillez réessayer dans quelques secondes`,
			'auth/user-disabled': () =>
				t`Le compte rattaché à ce lien a été désactivé`,
			'auth/user-mismatch': () => t`Identifiants incorrects`,
			'auth/user-not-found': () =>
				t`Aucun compte rattaché à cet e-mail n'a été trouvé`,
			'auth/weak-password': () =>
				t`Le mot de passe doit faire au moins 6 caractères`,
			'auth/wrong-password': () => t`Le mot de passe est incorrect`,
			else: () => t`Erreur du serveur distant`,
			mustBeAuthToBook: () =>
				t`Vous devez être connecté(e) pour réserver un Cocoon`,
			mustBeAuthToBookDesk: () =>
				t`Vous devez être connecté(e) pour réserver un Desk`,
			noScopesInUrl: () =>
				t`La page n'est pas accessible, veuillez vérifier le lien.`,
			'user.factuInfosIncomplete': () =>
				t`Informations de facturation incomplètes.`,
			'user.persoInfosIncomplete': () =>
				t`Informations personnelles incomplètes.`,
			default: () => t`Une erreur est survenue`,
		}),
		[t],
	)
}
